import React, { ComponentProps } from 'react';
import { useTranslation } from 'react-i18next';
import ContentMessage from '../../_lib/components/ContentMessage/ContentMessage';
import { ContactPerson } from '../../_lib/components/ContactPerson';
import { ContentList, ContentListItem } from '../../_lib/components/ContentList';
import { Namespace } from '../../translation/namespace';
import { FooterLink } from '../../components/molecules/FooterLink/FooterLink';
import { asBlock } from '../../_lib/BlockFetcher';
import { BlockType } from '../../types/api/ElementType';
import ILink from '../../types/ILink';

type ContactPersonsProps = {
  contactPersons: ContactPerson[];
  footerLink: ILink;
};

/**
 * Lists persons in ContentList
 */
export function ContactPersons({ contactPersons, footerLink }: ContactPersonsProps) {
  const { t } = useTranslation(Namespace.ContactPersons);
  if (contactPersons.length > 0) {
    return (
      <>
        <ContentList>
          {contactPersons.map(person => (
            <ContentListItem key={person.id}>
              <ContactPerson {...person} />
            </ContentListItem>
          ))}
        </ContentList>

        {footerLink && <FooterLink footerButtonLabel={t('contactpersonsFooterButton')} footerLink={footerLink} />}
      </>
    );
  }
  // we return a message, if no contact persons a linked to this page
  return (
    <>
      <ContentMessage text={t('noContactPerson')} />

      {footerLink && <FooterLink footerButtonLabel={t('contactpersonsFooterButton')} footerLink={footerLink} />}
    </>
  );
}

export const ContactPersonsBlock = asBlock(ContactPersons, BlockType.contactpersons);
export type ContactPersonsBlock = ComponentProps<typeof ContactPersonsBlock>;
